import Axios, { type AxiosInstance, type AxiosPromise } from 'axios';
import ApiService from './apiService';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';
import { featureFlagService } from '@life-time-inc/enterprise-framework-core';

interface IEmployeeProfileService {
	getEmployeeProfile(): AxiosPromise<ltFramework.IEmployeeProfileResponse>;
}

const FEATURE_ID = 'muxEmployeeServiceSpringApi';
const kong = window.lt.api.ltApiUrl + '/aem/mux-employee/v1';
const apim = window.lt.api.apimUrl + 'ux/teammember/v1';

export const EmployeeProfileServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: featureFlagService.isEnabled(FEATURE_ID) ? kong : apim,
	headers: {
		apiKey: window.lt.api.apimKey,
		'Ocp-Apim-Subscription-Key': window.lt.api.apimKey,
		'Content-Type': 'application/json; charset=UTF-8'
	}
});

export default class EmployeeProfileService extends ApiService implements IEmployeeProfileService {
	constructor() {
		super('employee-profile-service', EmployeeProfileServiceAxiosInstance);
	}

	public getEmployeeProfile(): AxiosPromise<ltFramework.IEmployeeProfileResponse> {
		return this.axiosInstance.get('/employee/profile');
	}
}

export const employeeProfileService = new EmployeeProfileService();
